/* eslint-disable import/prefer-default-export */

// Internal Imports
import { GRID } from "../constants";

// Destructuring
const { PRICEBOOK_COLUMNS } = GRID;

/**
 * @param {string} name - Field name.
 * @param {object} obj - Holds the column properties.
 */
export const generateBasedOnName = (name, object) => {
  const obj = object;
  switch (name) {
    case PRICEBOOK_COLUMNS.LIST_PRICE:
      obj.suppressSorting = true;
      return obj;
    case PRICEBOOK_COLUMNS.PRODUCT_CONFIG_TYPE:
      obj.minWidth = 131;
      return obj;
    case PRICEBOOK_COLUMNS.RECURRING_PERIOD:
      obj.minWidth = 98;
      return obj;
    case PRICEBOOK_COLUMNS.SCALE:
      obj.minWidth = 114;
      return obj;
    case PRICEBOOK_COLUMNS.SELLING_TERM:
      obj.minWidth = 102;
      return obj;
    case PRICEBOOK_COLUMNS.PRODUCT_DESC:
      obj.minWidth = 95;
      return obj;
    default:
      return obj;
  }
};



// WEBPACK FOOTER //
// ./src/mashupV2/Pricebook.js